import { useQuery } from '@apollo/client';
import { graphql } from '../gql';

export const GET_CLAIM_VENDORS = graphql(`
  query getVendors {
    entities(filters: { claimsVendor: true }) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          type
          status
          agency
          createdAt
          submissionType
          claimsVendor
          services {
            edges {
              node {
                uuid
                name
                type
              }
            }
          }
          aliases(filters: { source: PRIMARY, type: LEGAL_NAME }) {
            edges {
              node {
                uuid
                name
                type
                sources
              }
            }
          }
        }
      }
    }
  }
`);
export interface IUseClaimVendorsQueryArg {
  // claimUuid?: string;
}
export function useClaimVendorsQuery() {
  const { loading, data, error } = useQuery(GET_CLAIM_VENDORS, {});

  return {
    loading,
    error,
    data,
  };
}
